export const IGNORED_AXIOS_ERROR_CODES = [
  'ERR_NETWORK',
  'ERR_INTERNET_DISCONNECTED',
  'ERR_CANCELED',
] as const;

export type IgnoredAxiosErrorCode = (typeof IGNORED_AXIOS_ERROR_CODES)[number];
